module.exports = __webpack_public_path__ + "img/19.f80d5a5c.png";